define('paychex.app.messages/messages/MessageStatus175',[
    'paychex.app.common/messages/PaychexMessage',
    'paychex.core/InheritanceHelper'
], function( PaychexMessage, PIH ) {

    'use strict';

    /**
     * WEB175 is a message to indicate to the user that the deletion operation failed
     * @class paychex.app.common.messages.Web175Message
     */
    var MessageStatus175 = function message175 () {
        MessageStatus175.parent.constructor.apply(this, ['MSG175',
            'png.landing.messages.MS175.text',
            //    'The ' + objectType + ' could not be be deleted.',
            PaychexMessage.MESSAGE_STATUSES.ERROR,
            [{
                actionId: MessageStatus175.OK,
                actionName: 'OK',
                isDefault: true
            }]
        ]);
    };

    MessageStatus175.OK = 'OK';

    PIH.extend(MessageStatus175, PaychexMessage);
    return MessageStatus175;
});

